import { useSelector } from 'react-redux';

export const useHasFilledOutCustomAddress = () => {
  const { voiceConfig } = useSelector((state: { addOns: any }) => state.addOns);

  const { aptUnit, ...requiredFields } = voiceConfig.emergencyAddress;

  const hasFilledOutCustomAddress = Object.values(requiredFields).every(
    (value) => value
  );

  return { hasFilledOutCustomAddress };
};
